export const TAG_HISTORY = 'History';
export const TAG_SUMMARY = 'Summary';
export const TAG_SCRIPT = 'Script';
export const TAG_VOICEMAIL = 'Voicemail';
export const TAG_NOTE = 'Note';
export const TAG_SAVE = 'Save to';
export const TAG_GROUP_RESTARTED = 'Group Restarted';
export const TAG_GROUP_CHANGED = 'Group Changed';
export const TAG_UPDATED = 'Updated';
